Controller.$inject = ['$timeout', '$scope'];

function Controller($timeout, $scope) {
    let self = this;
    self.updateSlider = () => {
        const min = Number(self.min) || 0;
        const max = Number(self.max) || 0;
        const value = Number(self.ngModel) || 0;
        const range = (max - min);
        const clamped = range > 0 ? Math.max(min, Math.min(value, max)) : min;
        const percentage = range > 0 ? ((clamped - min) / range) * 100 : 0;
        self.filledWidth = percentage + '%';
    };

    self.onInputChange = ($event) => {
        self.updateSlider();
        $timeout(() => {
            self.onChange({$event});
        });
    };

    const getSliderSteps = (min, max, step) => {
        let steps = [];
        for (let i = min; i <= max; i += step) {
            steps.push(i);
        }
        return steps;
    };

    self.$onInit = () => {
        self.sliderSteps = getSliderSteps(self.min, self.max, self.step);
        self.updateSlider();

        // Reflect external model updates (e.g., audio timeupdate) in the UI
        $scope.$watch(() => self.ngModel, () => {
            self.updateSlider();
        });

        // Recompute when bounds change (e.g., duration loaded)
        $scope.$watchGroup([() => self.min, () => self.max, () => self.step], () => {
            self.sliderSteps = getSliderSteps(self.min, self.max, self.step);
            self.updateSlider();
        });
    };
}

export function HuiInputSlider() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            ngModel: '=',
            min: '<',
            max: '<',
            step: '<',
            color: '@',
            hName: '@',
            sizing: '@',
            onChange: '&'
        },
        transclude: true,
        controller: Controller,
        controllerAs: '$huiCtrl',
        template: ($element, $attrs) => {
            return `
                <div class="hui hui-input-slider"
                     role="slider"
                     aria-valuetext="{{ $huiCtrl.ngModel }}"
                     aria-valuenow="{{ $huiCtrl.ngModel }}"
                     aria-valuemin="{{ $huiCtrl.min }}"
                     aria-valuemax="{{ $huiCtrl.max }}"
                     tabindex="0"
                     ng-class="['hui-' + ($huiCtrl.color || 'accent'),
                                ($huiCtrl.sizing || 'md')]">
                    <div class="hui-input-slider-track">
                         <div class="hui-input-slider-filled" 
                              ng-class="['hui-' + ($huiCtrl.color || 'accent')]"
                              ng-style="{ width: $huiCtrl.filledWidth}">
                              <div class="hui-input-slider-thump" 
                                    ng-class="['hui-' + ($huiCtrl.color || 'accent')]"></div>
                         </div>  
                    </div>
                     <input type="range" min="{{$huiCtrl.min}}" max="{{$huiCtrl.max}}" step="{{$huiCtrl.step}}" 
                            aria-hidden="true"
                            name="{{$huiCtrl.hName}}"                  
                            class="hui-slider-input" 
                            ng-model="$huiCtrl.ngModel" 
                            ng-change="$huiCtrl.onInputChange($event)" />     
                </div>
            `;
        }
    };
}